import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import './ServicePages.css';
import SEO from '../SEO';

const Physiotherapy = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Pain relief and management',
    'Improved mobility and movement',
    'Recovery from injury or trauma',
    'Recovery from stroke or paralysis',
    'Pre and post-surgery rehabilitation',
    'Management of age-related medical problems'
  ];

  const treatments = [
    {
      name: 'Musculoskeletal Physiotherapy',
      description: 'Treats disorders affecting muscles, bones, and joints.'
    },
    {
      name: 'Neurological Physiotherapy',
      description: 'Focuses on disorders of the nervous system like stroke, Parkinson\'s disease, or multiple sclerosis.'
    },
    {
      name: 'Cardiorespiratory Physiotherapy',
      description: 'Helps patients with heart and lung conditions like COPD, asthma, or after cardiac surgery.'
    },
    {
      name: 'Geriatric Physiotherapy',
      description: 'Specialized for elderly patients dealing with age-related conditions.'
    }
  ];

  return (
    <div className="service-page physiotherapy-page">
      <SEO 
        title="Physiotherapy at Home in Bangalore"
        description="Expert physiotherapy services at home in Bangalore. Our qualified physiotherapists provide personalized treatment for pain relief, stroke recovery, and post-surgery rehabilitation."
        keywords="physiotherapy at home Bangalore, physiotherapist near me, home physiotherapy Bangalore, stroke rehabilitation, post-surgery physiotherapy, pain management"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Physiotherapy Services</h1>
                <p>Expert physiotherapy care delivered in the comfort of your home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/physiotherapy.jpg" alt="Physiotherapy Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Professional Physiotherapy at Your Doorstep</h2>
              <p>
                Our physiotherapy services bring expert care directly to your home, eliminating the need for travel and waiting rooms. 
                Our qualified physiotherapists work with you to develop personalized treatment plans that address your specific needs and goals.
              </p>
              <p>
                Whether you're recovering from surgery, managing chronic pain, or seeking to improve mobility, our physiotherapists 
                use evidence-based techniques to help you achieve optimal physical function and well-being.
              </p>
              
              <h3>Our Physiotherapy Treatments</h3>
              <Row className="treatment-cards">
                {treatments.map((treatment, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{treatment.name}</Card.Title>
                        <Card.Text>{treatment.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Physiotherapy</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Book Your Session Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Physiotherapy?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Experienced & certified physiotherapists</li>
                    <li>Personalized treatment plans</li>
                    <li>Convenient home visits</li>
                    <li>Modern equipment and techniques</li>
                    <li>Flexible scheduling options</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Ready to Start Your Recovery Journey?</h3>
              <p>Our expert physiotherapists are ready to help you achieve your health goals.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule Your Physiotherapy Session
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Physiotherapy"
      />
    </div>
  );
};

export default Physiotherapy;
